<template>

    <div>

        <compose-message-component v-if="!isLoading"
                                   :pre-load-compose-message-init-data="composeMessageInitData"></compose-message-component>

        <message-detail-modal v-if="!isLoading"
                              id="message-detail-dialog"
                              :cms-content-blocks="cmsMessageListingContentBlocks"
                              :cms-compose-content-blocks="composeMessageInitData.portalAppointmentComposeMessageContentBlocks"
                              :detail-message-chain="selectedMessageDetail.messageChain"
                              :attachment-group-id="attachmentGroupId"
                              :show-delete-button="true"
                              :show-reply-button="true"
                              :show-restore-button="false"
                              :disable-uploads="true"
                              @onReloadMessages="reloadMessageList">
        </message-detail-modal>


        <div class="card message-header kb-dashboard-tile">
            <div class="card-body pl-0 pr-0 pb-0">

                <div class="row dashboard-header-container pl-4 pr-4" :class="paddingCss">
                    <div class="col d-flex align-items-start align-items-center">
                        <i class="icon-button-w-text fa-fw fal fa-envelope-open-text d-inline-block message-color right-nav-icon"></i>
                        <h4 class="ml-2 d-inline dashboard-header">{{cmsMessageListingContentBlocks.messages}}</h4>
                    </div>
                </div>

                <div v-if="!isLoading" class="border-top">
                    <div v-if="howManyTotalMessages == 0">
                        <div class="pt-3 pb-3" :class="paddingCss">
                            <div class="col">
                                {{cmsMessageListingContentBlocks.sendQuestionsToMSK}}
                            </div>
                        </div>

                        <div :class="newMessageCss">
                            <div class="col d-flex justify-content-left">
                                <a @click.prevent="goToComposeMessage" :disabled="isLoading" href="#" target="_blank" role="button" class="bg-portal-primary-blue btn text-white" aria-label="Compose New Message" >
                                    <i class="fs-16 icon-button-w-text far fa-envelope"></i>
                                    {{cmsMessageListingContentBlocks.newMessage}}
                                </a>
                            </div>
                        </div>
                    </div>

                    <div v-if="howManyTotalMessages > 0" class="mt-3">
                        <div v-if="dashboardUnReadMessageListing.length == 0">
                            <div class="text-portal-dark-grey">
                                <div class="pt-3 pb-3" :class="paddingCss">
                                    <div class="row">
                                        <div class="col">
                                            {{cmsMessageListingContentBlocks.noUnreadMessages}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4" :class="newMessageCss">
                                <div class="col d-flex justify-content-left">
                                    <a :href="messagePageUrl" role="button" class="btn btn-outline-primary entry-button">
                                        {{cmsMessageListingContentBlocks.viewMessages}}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div v-if="dashboardUnReadMessageListing.length > 0">
                            <div v-if="dashboardUnReadMessageListing.length == 1" class="text-portal-dark-grey ">
                                <div class="pt-3 pb-3" :class="paddingCss">
                                    <div class="row">
                                        <div class="col">
                                            <b>{{cmsMessageListingContentBlocks.unReadMessage}}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="dashboardUnReadMessageListing.length > 1">
                                <div class="pt-3 pb-3" :class="paddingCss">
                                    <div class="row">
                                        <div class="col">
                                            <b>You have {{dashboardUnReadMessageListing.length}} unread messages.</b>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4" :class="newMessageCss">
                                <div class="col d-flex justify-content-left">
                                    <a :href="messagePageUrl" role="button" class="bg-portal-primary-blue btn text-white">
                                        {{cmsMessageListingContentBlocks.viewMessages}}
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>
    </div>

</template>

<style>
    .compose-no-message {
        margin-top: 1.7rem !important;
        margin-bottom: 1.7rem !important;
    }
</style>

<script>
    import { KbMessageHttpSvc } from '@KBHttpServices/kb.message.httpservice';
    import { MessageHttpSvc } from '@SharedHttpServices/message.httpservice';
    import composeMessageComponent from '@PortalEntryPoints/Messages/ComposeMessage/compose.message.index.vue';
    import messageDetailDialog from '@PortalEntryPoints/Messages/Index/components/common/message.detail.dialog.vue';
    import { createAttachmentGroupGuid } from '@PortalEntryPoints/Messages/ComposeMessage/message.service';
    import messageGroupRecords from './message.group.records.vue';
    import MessageEventBus from '@PortalEntryPoints/Messages/ComposeMessage/message.event.bus';

    export default {
        props: {
            messagePageUrl: { type: String }
        },
        data: function () {
            return {
                isLoading: true,
                dashboardUnReadMessageListing: [],
                dashboardReadMessageListing: [],
                cmsMessageListingContentBlocks: {},
                composeMessageInitData: {},
                attachmentGroupId: null,

                selectedMessageDetail: {
                    messageChain: null
                },

                paddingCss: 'pl-4 pr-4'
            }
        },
        components: {
            'compose-message-component': composeMessageComponent,
            'message-detail-modal': messageDetailDialog,
            'message-group-records': messageGroupRecords
        },
        created: function () {

            KbMessageHttpSvc.DashboardMessageInit()
                .done(response => {

                    this.dashboardUnReadMessageListing = response.dashboardMessageListing.unreadMessages;
                    this.dashboardReadMessageListing = response.dashboardMessageListing.readMessages;
                    this.cmsMessageListingContentBlocks = response.cmsMessageListingContentBlocks;
                    this.composeMessageInitData = response.composeMessageInitData;
                    this.isLoading = false;
                });
        },
        computed: {

            newMessageCss: function () {
                if (this.howManyTotalMessages > 0) {
                    return [this.paddingCss];
                }

                return [this.paddingCss, 'compose-no-message'];
            },

            howManyTotalMessages: function () {
                return this.dashboardUnReadMessageListing.length + this.dashboardReadMessageListing.length;
            }

        },
        mounted: function () {

            $(document).on('hidden.bs.modal', '#message-detail-dialog', e => {
                this.reloadMessageList();
            });
        },
        methods: {

            goToMessageDetail: function (selectedRecord) {

                MessageHttpSvc.MessageDetailSelect(selectedRecord.msgId)
                    .done(response => {
                        this.attachmentGroupId = createAttachmentGroupGuid();
                        this.selectedMessageDetail.messageChain = response;

                        $('#message-detail-dialog').modal('show');
                    });
            },

            reloadMessageList: function () {

                KbMessageHttpSvc.KbMessageListReload()
                    .done(response => {
                        this.dashboardUnReadMessageListing = response.unreadMessages;
                        this.dashboardReadMessageListing = response.readMessages;
                    });
            },

            goToComposeMessage: function () {
                $('#compose-message-dialog').modal('show');
            }
        }
    };
</script>

